(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-ala-ambient-video]:not([data-film-ready])').forEach(video => {
      video.dataset.filmReady = 'true';
      const button = video.closest('.os-hero').querySelector('[data-ala-video-toggle]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = matchMedia('(max-width: 760px)');
      const saveData = navigator.connection?.saveData;
      let visible = false;
      let userPaused = false;
      video.muted = true;
      const updateButton = () => {
        button.textContent = video.paused ? '▷' : 'Ⅱ';
        button.setAttribute('aria-label', video.paused ? 'Arka plan videosunu oynat' : 'Arka plan videosunu duraklat');
      };
      const sync = () => {
        video.poster = mobile.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
        if (reduced.matches || saveData || !visible || document.hidden || userPaused) {
          video.pause();
          updateButton();
          return;
        }
        const src = mobile.matches ? video.dataset.mobileUrl : video.dataset.desktopUrl;
        if (video.getAttribute('src') !== src) { video.src = src; video.load(); }
        video.play().then(() => { button.hidden = false; updateButton(); }).catch(() => { button.hidden = false; updateButton(); });
      };
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        sync();
      }, {threshold:0.05});
      observer.observe(video);
      button.addEventListener('click', () => { userPaused = !video.paused; sync(); });
      video.addEventListener('play', updateButton);
      video.addEventListener('pause', updateButton);
      reduced.addEventListener('change', sync);
      mobile.addEventListener('change', sync);
      document.addEventListener('visibilitychange', sync);
    });
    root.querySelectorAll('[data-ala-product-film]:not([data-film-ready])').forEach(details => {
      details.dataset.filmReady = 'true';
      const video = details.querySelector('video');
      details.addEventListener('toggle', () => {
        if (!details.open) { video.pause(); return; }
        if (!video.getAttribute('src')) {
          video.src = video.dataset.videoUrl;
          video.preload = 'metadata';
          video.load();
        }
      });
      new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) video.pause();
      }).observe(video);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
